import React from 'react';

export default () => (
  <section className="text-center space--xxs">
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-10 col-lg-8">
          <h2>Manage your mocks</h2>
        </div>
      </div>
    </div>
  </section>
);
